export default "__VITE_ASSET__DINqJGrD__"